import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get, map } from 'lodash';
import { closeModal } from '../../../../common/components/Modal/ModalRedux';
import { Button, Modal } from '../../../../common/components';
import { Field } from 'redux-form';
import PolicyUpgradesBox from '../PolicyUpgrades/components/PolicyUpgradesBox/PolicyUpgradesBox';

const FORM_NAME = 'policyOptionsMTA';

class PolicyOptionsMTA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isGoldUpgraded: null,
      scheme: [],
    };
  }

  handleClose() {
    const { dispatch, onGoToReview } = this.props;
    dispatch(closeModal(FORM_NAME));
    onGoToReview();
  }

  handleOnHide() {
    const { dispatch, change } = this.props;
    dispatch(change('data.attributes.metadata.options.travel_dispute', false));
    dispatch(change('data.attributes.metadata.options.end_supplier_failure', false));
    dispatch(change('data.attributes.metadata.options.smart_luggage', false));
  }

  render() {
    const { product, submitting, selectedSchemes } = this.props;
    const getSelectedQuote = get(product, 'quotes');

    let selectedScheme = [];
    map(getSelectedQuote, (quote, key) => {
      if (
        selectedSchemes &&
        selectedSchemes.length > 0 &&
        key === selectedSchemes[0].id
      ) {
        selectedScheme = quote;
      }
    });

    const boltOns = get(selectedScheme, 'meta.information.bolt_ons');

    const submitButton = (
      <Button
        type="submit"
        bsStyle="primary"
        className="settings-button"
        disabled={product.isCalculating}
        isLoading={submitting}
        label="continue"
        handleClick={() => this.handleClose()}
      />
    );

    return (
      <div>
        <Modal
          name={FORM_NAME}
          title={'Policy Options'}
          close
          footer={submitButton}
          onHide={this.handleOnHide.bind(this)}
        >
          <div style={{ paddingBottom: '0' }}>
            <Field
              name="data.attributes.metadata.policy_upgrade"
              component={PolicyUpgradesBox}
              isGold={this.state.isGoldUpgraded}
              boltOns={boltOns}
              product={product}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

export default connect()(PolicyOptionsMTA);
